import React, { Component, useState, useEffect } from "react";
//remember, have to replace data-feather with font awesome icons
import _ from "lodash";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCcDiscover, faCcMastercard, faCcVisa } from "@fortawesome/free-brands-svg-icons";
import Select from "react-select";
import WindowedSelect from "react-windowed-select";
import dayjs from "dayjs";
import { Card, Row, Col, Table, Input, DatePicker, Button, Popconfirm, Tag, Modal, Tooltip, Space } from "antd";
import { faLink, faPaperPlane, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

function Payments(props) {
  const [daterange, setDaterange] = useState([dayjs().subtract(3, "months"), dayjs()]);
  const [fundings, setFundings] = useState([]);
  const [filteredFundings, setFilteredFundings] = useState([]);
  const [payments, setPayments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedPayment, setSelectedPayment] = useState(null);
  const [linkingModalOpen, setLinkingModalOpen] = useState(false);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isCompanySetupForQBO, setIsCompanySetupForQBO] = useState(false);

  const GetPayments = async () => {
    let response = await props.AxiosRequest("/api/payments/get", {
      start_date: dayjs(daterange[0]).startOf("day").format("YYYY-MM-DD"),
      end_date: dayjs(daterange[1]).endOf("day").format("YYYY-MM-DD"),
    });
    setPayments(
      response.data.payments.map((m) => {
        return { ...m, key: m.id };
      }),
    );
  };
  const GetFundings = async () => {
    let response = await props.AxiosRequest("/api/fundings/get", {
      start_date: dayjs(daterange[0]).startOf("day").format("YYYY-MM-DD"),
      end_date: dayjs(daterange[1]).endOf("day").format("YYYY-MM-DD"),
    });
    setFundings(
      response.data.fundings.map((m) => {
        return { ...m, key: m.id };
      }),
    );
  };

  const GetCompany = async () => {
    let response = await props.AxiosRequest("/api/companies/get");
    setIsCompanySetupForQBO(response.data.company.qbo_enabled);
  };
  const GetClients = async () => {
    let response = await props.AxiosRequest("/api/clients/get/all");
    setClients(
      response.data.clients.map((m) => {
        return { ...m, key: m.id, value: m.id, label: m.name };
      }),
    );
  };
  const SendPaymentToQBO = async (value) => {
    let response = await props.AxiosRequest(
      "/api/payments/send-to-qbo",
      {
        payment_id: value,
      },
      true,
    );
    props.MakeNotification("success", response?.data?.message, 3000, "topRight", true);
  };
  const LinkPayment = async () => {
    await props.AxiosRequest("/api/payments/update/link-client", {
      transaction_id: selectedPayment.transaction_id,
      clients_xref: selectedClient.id,
    });
    setLinkingModalOpen(false);
    setSelectedPayment(null);
    setSelectedClient(null);
    GetFundings();
    GetPayments();
  };
  const FilterFundingsAndPayments = async () => {
    // this is not a normal filter, first we join the payments to the fundings
    let fundings_copy = fundings;
    fundings_copy = fundings_copy.map((m) => {
      let related_payments = payments.filter((f) => f.merchant_funding_id === m.merchant_funding_id);
      return { ...m, number_of_payments: related_payments.length, payments: related_payments };
    });
    //after here is normal search (with additional search of the children)
    if (!searchTerm) return setFilteredFundings(fundings_copy);
    let filtered_list = fundings_copy.filter((f) =>
      _.toLower(f.merchant_funding_id).indexOf(_.toLower(searchTerm)) > -1 ||
      _.toLower(f.effective_date).indexOf(_.toLower(searchTerm)) > -1 ||
      _.toLower(f.net_amount).indexOf(_.toLower(searchTerm)) > -1 ||
      _.toLower(f.status).indexOf(_.toLower(searchTerm)) > -1 ||
      f.payments.filter((p) =>
        _.toLower(p.client_name).indexOf(_.toLower(searchTerm)) > -1 ||
        _.toLower(p.customer_name).indexOf(_.toLower(searchTerm)) > -1 ||
        _.toLower(p.merchant_funding_id).indexOf(_.toLower(searchTerm)) > -1 ||
        _.toLower(p.transaction_id).indexOf(_.toLower(searchTerm)) > -1 ||
        _.toLower(props.FormatNumberToCurrency(p.amount)).indexOf(_.toLower(searchTerm)) > -1
          ? true
          : false,
      ).length > 0
        ? true
        : false,
    );
    setFilteredFundings(filtered_list);
  };

  useEffect(() => {
    GetPayments();
    GetFundings();
    GetCompany();
    GetClients();
  }, []);

  useEffect(() => {
    if (daterange[0] && daterange[1]) {
      GetFundings();
      GetPayments();
    }
  }, [daterange]);

  useEffect(() => {
    FilterFundingsAndPayments();
  }, [searchTerm, fundings, payments]);

  const fundings_columns = [
    {
      title: "Funding ID",
      dataIndex: "merchant_funding_id",
      key: "merchant_funding_id",
      render: (value) => <Input readOnly value={value} />,
      sorter: (a, b) => (a.merchant_funding_id.toUpperCase() > b.merchant_funding_id.toUpperCase() ? 1 : -1),
    },
    {
      title: "Date",
      dataIndex: "effective_date",
      key: "effective_date",
      render: (value) => props.MakeDateTimeReadable(value),
      sorter: (a, b) => (a.effective_date > b.effective_date ? 1 : -1),
      defaultSortOrder: "descend",
    },
    {
      title: "Amount",
      dataIndex: "net_amount",
      key: "net_amount",
      render: (value) => props.FormatNumberToCurrency(value),
      sorter: (a, b) => (a.net_amount > b.net_amount ? 1 : -1),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => <Tag color={value === "completed" ? "success" : "warning"}>{_.startCase(value)}</Tag>,
      sorter: (a, b) => (a.status.toUpperCase() > b.status.toUpperCase() ? 1 : -1),
    },
    {
      title: "Payments Associated with Funding",
      dataIndex: "number_of_payments",
      key: "number_of_payments",
      align: "right",
      render: (value, row) => value + " Payment(s)",
    },
  ];
  const payments_columns = [
    {
      title: "Payee",
      dataIndex: "customer_name",
      key: "customer_name",
      sorter: (a, b) => (a.customer_name.toUpperCase() > b.customer_name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Client",
      dataIndex: "client_name",
      key: "client_name",
      render: (value, row) =>
        value ? (
          <Link to={"/client-details/" + row.client_tag}>{value}</Link>
        ) : (
          <Button
            size="small"
            onClick={() => {
              setSelectedPayment(row);
              setLinkingModalOpen(true);
            }}
          >
            Link Payment
          </Button>
        ),
      sorter: (a, b) => (a.client_name?.toUpperCase() > b.client_name?.toUpperCase() ? 1 : -1),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (value) => props.FormatNumberToCurrency(value),
      sorter: (a, b) => (a.amount > b.amount ? 1 : -1),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => <Tag color={value === "exported" ? "success" : "warning"}>{_.startCase(value)}</Tag>,
      sorter: (a, b) => (a.status.toUpperCase() > b.status.toUpperCase() ? 1 : -1),
    },
    {
      title: "Date",
      dataIndex: "received_at",
      key: "received_at",
      render: (value) => props.MakeDateTimeReadable(value),
      sorter: (a, b) => (a.received_at > b.received_at.toUpperCase() ? 1 : -1),
    },
    {
      title: "Memo",
      dataIndex: "memo",
      key: "memo",
      render: (value) => <Input.TextArea readOnly value={value} />,
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (value) => <Input readOnly value={value} />,
      sorter: (a, b) => (a.transaction_id.toUpperCase() > b.transaction_id.toUpperCase() ? 1 : -1),
    },
    {
      title: "Funding ID",
      dataIndex: "merchant_funding_id",
      key: "merchant_funding_id",
      render: (value) => <Input readOnly value={value} />,
      sorter: (a, b) => (a.merchant_funding_id.toUpperCase() > b.merchant_funding_id.toUpperCase() ? 1 : -1),
    },
    {
      title: "Card Details",
      dataIndex: "card_last_4",
      key: "card_last_4",
      render: (value, row) => {
        let icon = faQuestionCircle;
        if (row.type == "visa") icon = faCcVisa;
        if (row.type == "mast") icon = faCcMastercard;
        if (row.type == "disc") icon = faCcDiscover;

        return (
          <>
            <Row gutter={[4, 4]}>
              <Col span={24} className="text-center">
                <FontAwesomeIcon icon={icon} />
              </Col>
              <Col span={24} className="text-center">
                **** {row.card_last_4}
              </Col>
            </Row>
          </>
        );
      },
      sorter: (a, b) => (a.merchant_funding_id.toUpperCase() > b.merchant_funding_id.toUpperCase() ? 1 : -1),
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      render: (value, row) => (
        <Space>
          <Tooltip title="Link (or Re-Link) Payment to Client">
            <Button
              size="small"
              onClick={() => {
                setSelectedPayment(row);
                setLinkingModalOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faLink} className="mr-2" />
              Link
            </Button>
          </Tooltip>
          {isCompanySetupForQBO ? (
            <Popconfirm
              onConfirm={() => {
                SendPaymentToQBO(value);
              }}
              okText="Send"
              title="Are you sure?"
              description={
                <div className="text-center">
                  Are you sure you want to send this payment to QuickBooks Online?
                  <br />
                  Payments are automatically exported. Doing this can cause duplicate payments to show up in QuickBooks Online.
                </div>
              }
            >
              <Tooltip title="Send Payment to Quickbooks Online">
                <Button size="small" type="primary">
                  <FontAwesomeIcon icon={faPaperPlane} className="mr-2" />
                  Export
                </Button>
              </Tooltip>
            </Popconfirm>
          ) : null}
        </Space>
      ),
    },
  ];

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Payments</h1>
        </div>
        <Row>
          <Card title="Fundings and Payments" className="w-100">
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <label className="col-form-label-sm">Date Range</label>
                <DatePicker.RangePicker
                  className="w-100"
                  value={daterange}
                  onCalendarChange={(dates) => {
                    if (!dates) return setDaterange([null, null]);
                    setDaterange(dates);
                  }}
                  allowClear={false}
                  format="MM/DD/YYYY"
                />
              </Col>
              <Col span={16} className="text-right">
                {/* <label className="col-form-label-sm w-100">&nbsp;</label>
                <Button type="primary">Submit</Button> */}
              </Col>
              <Col span={16}></Col>
              <Col span={8}>
                <Input
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                />
              </Col>
              <Col span={24}>
                <Table
                  className="table-striped"
                  columns={fundings_columns}
                  dataSource={filteredFundings}
                  expandable={{
                    // expandRowByClick: true,
                    expandedRowRender: (e) => <Table columns={payments_columns} dataSource={payments.filter((f) => f.merchant_funding_id === e.merchant_funding_id)} pagination={false} />,
                  }}
                />
              </Col>
            </Row>
          </Card>
        </Row>
        <Modal
          title="Link Payment to Client"
          centered
          open={linkingModalOpen}
          onCancel={() => {
            setLinkingModalOpen(false);
            setSelectedPayment(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setLinkingModalOpen(false);
                  setSelectedPayment(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  LinkPayment();
                }}
              >
                Link Payment
              </Button>
            </>
          }
        >
          {selectedPayment ? (
            <>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col span={24}>
                  <label className="col-form-label-sm">Payment to Link *</label>
                  <Input readOnly value={selectedPayment.transaction_id} />
                </Col>
                <Col span={24}>
                  <label className="col-form-label-sm w-100">Client to Link to *</label>
                  <WindowedSelect options={props.MakeClientOptions(clients)} value={selectedClient} onChange={(e) => setSelectedClient(e)} />
                </Col>
              </Row>
            </>
          ) : null}
        </Modal>
      </div>
    </main>
  );
}

export default Payments;
